import Vue from 'vue'
import Vuex from 'vuex'
import { SITE_API_, API_ } from "@/Store/app_url.js";
import auth from './Store/Module/auth'
import feed from './Store/Module/feed'
import loader from './Store/Module/loader'
import user from './Store/Module/user'
import message from './Store/Module/message'
import company from './Store/Module/company'
import landing from './Store/Module/landing'
import search from './Store/Module/search'
import customer from './Store/Module/customer'
import skills from './Store/Module/skills'
import ai from './Store/Module/ai'
import accounts from "./Store/Module/accounts.js";
import leads from "./Store/Module/leads.js";
import candidates from "./Store/Module/candidates.js";
import task from "./Store/Module/task.js";
import heatmap from "./Store/Module/heatmap.js";
import report from "./Store/Module/report.js";
import process_messages from "./Store/Module/process_messages.js";
import instructor from "./Store/Module/instructor.js";
import internship from "./Store/Module/internship.js";
import Cvs from "./Store/Module/cvs.js";
import Communication from "./Store/Module/communication.js";
import Matrix from "@/Store/Module/matrix"
import Calendar from "@/Store/Module/calendar"


Vue.use(Vuex)
const debug = process.env.NODE_ENV !== "production";


export default new Vuex.Store({
    state: {
        side_bar: false,
        crm_prefix: '',
        wizard_active_menu: "",
        path: [],
        dialog_class: "",
        navigationHistory: [],
        removedNavigationPath: null,
        isNavigationBackDirection: false,
        SITE_API: SITE_API_,
        API: API_,
        isDownloadingCV: false,
        canCVSaveHistory: true,
    },
    mutations: {
        ['SET_WIZARD_ACTIVE_MENU']: (state, payload) => {
            state.wizard_active_menu = payload;
        },
        ['SET_CRM_PREFIX']: (state, payload) => {
            if (Vue.localStorage.get("role")) {
                state.crm_prefix = "/" + Vue.localStorage.get("role");
            } else {
                state.crm_prefix = payload.prefix
            }
        },
        ['SET_PATH']: (state, payload) => {
            state.path = [];
            state.path = payload
        },
        ['SET_DIALOG_CLASS']: (state, payload) => {
            state.dialog_class = payload
        },
        ['SET_NAVIGATION_HISTORY']: (state, payload) => {
            state.navigationHistory.push(payload)
        },
        ['REMOVE_NAVIGATION_HISTORY']: (state, payload) => {
            state.removedNavigationPath = state.navigationHistory.pop()
        },
        ['SET_NAVIGATION_DIRECTION']: (state, payload) => {
            state.isNavigationBackDirection = payload
        },
        ['SET_DOWNLOADING_CV']: (state, payload) => {
            state.isDownloadingCV = payload
        },
        ['SET_CV_SAVE_HISTORY']: (state, payload) => {
            state.canCVSaveHistory = payload
        },
    },
    actions: {
        saveNavigationHistory: ({ commit }, payload) => {
            commit('SET_NAVIGATION_HISTORY', payload)
        },
        removeNavigationHistory: ({ state, commit }, payload) => {
            commit('REMOVE_NAVIGATION_HISTORY', payload)
            return state.removedNavigationPath;
        }
    },
    getters: {
        getNavigationHistory: state => {
            return state.navigationHistory
        },
        get_crm_prefix(state) {
            if (Vue.localStorage.get("role")) {
                return "/" + Vue.localStorage.get("role");
            }
            return state.crm_prefix;
        },
        get_path(state) {
            return state.path;
        },
        get_dialog_class(state) {
            return state.dialog_class;
        }

    },
    modules: {
        auth,
        feed,
        loader,
        user,
        message,
        company,
        landing,
        search,
        customer,
        skills,
        ai,
        accounts,
        leads,
        candidates,
        task,
        heatmap,
        report,
        process_messages,
        instructor,
        internship,
        Cvs,
        Communication,
        Matrix,
        Calendar
    },
    strict: debug

});